import React, { useEffect, useState } from 'react';
import {
    FormControl, FormControlLabel, FormHelperText, FormLabel, Grid,
    IconButton, Radio, RadioGroup, Typography, Button, Box
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { AppSelect } from './ProviderInputComponents';
import { useTranslation } from "react-i18next";
import useStyles from "./Common.style";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Minimize from '@material-ui/icons/Minimize';
import { RepLIProviderTextField } from '../../../components';
import { geneticTestingTypes, geneticCancerGene } from '../../../data/db';
import { arrayOfNumbers } from '../../../services/util.service';

const GeneticTesting = props => {
    const classes = useStyles();
    const { t } = useTranslation();
    // const MenuProps = {
    //     PaperProps: {
    //         style: {
    //             width: 250
    //         }
    //     },
    //     getContentAnchorEl: null,
    //     anchorOrigin: {
    //         vertical: "bottom",
    //         horizontal: "center"
    //     },
    //     transformOrigin: {
    //         vertical: "top",
    //         horizontal: "center"
    //     },
    //     variant: "menu"
    // };

    let birthYear = new Date(props.dateOfBirth).getFullYear();
    let firstYear = birthYear + 10;
    let currentYear = new Date(Date.now()).getFullYear();
    let geneticTestingYears = arrayOfNumbers(firstYear, currentYear - firstYear + 1);

    const [autoUpdate, setAutoUpdate] = useState(false);
    // const [expandedPanel, setExpandedPanel] = useState(false);
    // const handleAccordionChange = (panel) => (event, isExpanded) => {
    //     setExpandedPanel(isExpanded ? panel : false);
    // };

    useEffect(() => {
        if (props.submitted) props.validator.showMessages();
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
    }, [props.submitted, props.validator, props.items]);

    return (
        <Grid container className={classes.questionnaireContainer}>
            {/* <Accordion onChange={handleAccordionChange('panel1')} style={{ width: '100%' }}>
                <AccordionSummary
                    expandIcon={
                        expandedPanel ? <Minimize /> :
                            <AddIcon />
                    }
                    className={classes.accordionMarginStyle}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography variant="h5">Genetic Testing</Typography>
                </AccordionSummary>
                <AccordionDetails> */}
            <Typography variant="h5" style={{ marginBottom: 10 }}>Genetic Testing</Typography>
            <Grid container xs={12}>
                <Grid item xs={12}>
                    {/* Genetic Testing */}
                    <Typography gutterBottom>{`${t('module.provider.addPatient.form.labels.anyGeneticTesting')}*`}</Typography>
                    <FormControl
                        component="fieldset"
                        error={props.submitted && !props.validator.fieldValid('anyGeneticTesting')}
                    >
                        {/* <FormLabel className={classes.formLabelStyle}>
                            {`${t('module.provider.addPatient.form.labels.anyGeneticTesting')}*`}
                        </FormLabel> */}
                        <RadioGroup row
                            aria-label="Genetic Testing"
                            value={props.anyGeneticTesting}
                            onChange={props.onGenticTestingChange}
                        >
                            {["Yes", "No", "Unsure"].map((answer, i) =>
                                <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                            )}
                        </RadioGroup>
                        <FormHelperText>
                            {props.validator.message('anyGeneticTesting', props.anyGeneticTesting, 'required')}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <Box display={props.anyGeneticTesting === 'Yes' ? 'block' : 'none'}>
                        <>
                            {/* Genetic testing */}
                            {props.items?.map((testing, i) => {
                                return (
                                    <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i} >
                                        <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                            <span>{t('common.substantive.geneticTest')} #{i + 1}</span>
                                            <IconButton aria-label="delete" color="inherit" onClick={props.onGeneticTestingRemove(i)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>

                                        {/* Genetic Testing Type */}
                                        <Grid item xl={12} md={12} className={classes.appSelectGridItem}>
                                            <AppSelect
                                                id={`geneticTestingType${i + 1}`}
                                                value={testing.testType}
                                                label="What type of genetic testing did you have?*"
                                                items={[...geneticTestingTypes]}
                                                onChange={props.onDataChange(i, 'testType')}
                                                fullWidth
                                                error={props.submitted && !props.validator.fieldValid(`test_#${i + 1}_type`)}
                                                helperText={props.validator.message(`test_#${i + 1}_type`, testing.testType, 'required')}
                                            />
                                        </Grid>

                                        {/* Any Positive Genetic Testing */}
                                        <Grid item xl={12} md={12}>
                                            <Typography gutterBottom>{`${t('common.substantive.positiveGeneticTesting')}*`}</Typography>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`test_#${i + 1}_anyPositiveGeneticTesting`)}>
                                                {/* <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.positiveGeneticTesting')}*`}</FormLabel> */}
                                                <RadioGroup row
                                                    aria-label="Genetic Testing"
                                                    value={testing.anyPositiveGeneticTesting}
                                                    onChange={e => props.onPositiveGeneticTestingChange(i, e.target.value)}
                                                >
                                                    {["Yes", "No", "Unsure"].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`test_#${i + 1}_anyPositiveGeneticTesting`, testing.anyPositiveGeneticTesting, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>

                                        {/* Genetic Testing Screening */}
                                        <Box style={{ width: "100%" }} display={testing.anyPositiveGeneticTesting === 'Yes' ? 'block' : 'none'}>

                                            {/* Other Genetic Testing Type */}
                                            <Box className={classes.inputSection}
                                                display={(testing.testType === 'Other' || testing.testType === 'Carrier screening') ? 'block' : 'none'}>
                                                <Grid item xs={12}>
                                                    <FormControl variant="outlined" fullWidth >
                                                        <RepLIProviderTextField
                                                            label="What did your positive carrier screening test show?*"
                                                            value={testing.otherTestType}
                                                            inputProps={{ maxLength: 2500 }}
                                                            onChange={props.onDataChange(i, 'otherTestType')}
                                                            autoFocus
                                                            error={props.submitted && !props.validator.fieldValid(`test_#${i + 1}_otherTestType`)}
                                                            helperText={props.validator.message(`test_#${i + 1}_otherTestType`, testing.otherTestType, `other_testType:${testing.testType + ',' + testing.anyPositiveGeneticTesting}`)}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Box>

                                            {/* Genetic Cancer Testing Gene Types */}
                                            <Box className={classes.inputSection} display={testing.testType === 'Cancer genetic testing' ? 'block' : 'none'}>
                                                <Grid item xs={12}>
                                                    {/* <Typography variant="h6">What gene had a positive result in it?*</Typography> */}
                                                    <AppSelect
                                                        id={`cancerGeneType${i + 1}`}
                                                        label="What gene had a positive result in it?*"
                                                        value={testing.cancerGeneType}
                                                        items={[...geneticCancerGene]}
                                                        onChange={props.onDataChange(i, 'cancerGeneType')}
                                                        fullWidth
                                                        error={props.submitted && !props.validator.fieldValid(`test_#${i + 1}_cancerGeneType`)}
                                                        helperText={props.validator.message(`test_#${i + 1}_cancerGeneType`, testing.cancerGeneType, `cancer_geneType:${testing.testType + ',' + testing.anyPositiveGeneticTesting}`)}
                                                    />
                                                </Grid>
                                            </Box>

                                            {/* Genetic Testing Year */}
                                            <Grid item xs={12} className={classes.gridItemMarginStyle}>
                                                {/* <Typography variant="h6">Year of Genetic Testing*</Typography> */}
                                                <AppSelect
                                                    id={`testingYear${i + 1}`}
                                                    label="Year of Genetic Testing*"
                                                    value={testing.year}
                                                    items={['Unknown',...geneticTestingYears]}
                                                    onChange={props.onDataChange(i, 'year')}
                                                    fullWidth
                                                    error={props.submitted && !props.validator.fieldValid(`test_#${i + 1}_year`)}
                                                    helperText={props.validator.message(`test_#${i + 1}_year`, testing.year, `test_field_req:${testing.anyPositiveGeneticTesting}`)}
                                                />
                                            </Grid>

                                            {/* copy of the testing */}
                                            <Grid item xs={12}>
                                                <Typography gutterBottom>{`${t('common.substantive.doYouHaveCopyOfGeneticTest')}*`}</Typography>
                                                <FormControl
                                                    component="fieldset"
                                                    error={props.submitted && !props.validator.fieldValid(`test_#${i + 1}_copyOfGeneticTesting`)}>
                                                    {/* <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.doYouHaveCopyOfGeneticTest')}*`}</FormLabel> */}
                                                    <RadioGroup row
                                                        aria-label="Genetic Testing"
                                                        value={testing.copyOfGeneticTesting}
                                                        onChange={props.onDataChange(i, 'copyOfGeneticTesting')}
                                                    >
                                                        {["Yes", "No", "Unsure"].map((answer, i) =>
                                                            <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                        )}
                                                    </RadioGroup>
                                                    <FormHelperText style={{ marginLeft: '15px' }}>
                                                        {props.validator.message(`test_#${i + 1}_copyOfGeneticTesting`, testing.copyOfGeneticTesting, `test_field_req:${testing.anyPositiveGeneticTesting}`)}
                                                    </FormHelperText>
                                                </FormControl>
                                            </Grid>

                                        </Box>
                                    </Grid>
                                )
                            })}
                            <Grid item xs={12} style={{ marginBottom: 15 }}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddIcon />}
                                    onClick={props.onGeneticTestingAdd}
                                >
                                    {t('module.provider.addPatient.form.button.addGeneticTesting')}
                                </Button>
                            </Grid>
                        </>
                    </Box>
                </Grid>
            </Grid >
            {/* </AccordionDetails>
            </Accordion> */}
        </Grid >
    )
}

export default GeneticTesting;